import { SpotPrice } from '@store/types';
import { useAppSelector } from '@store/selectors';

// prettier-ignore
export const useSpotPrice = (): SpotPrice => useAppSelector((state) => state.spotPrice);
